"use client";

import { useState, useEffect } from "react";
import { Search, X } from "lucide-react";
import { usePathname } from "next/navigation";
import GlobalSearch from "./GlobalSearch";

export default function HeaderSearch() {
    const [isOpen, setIsOpen] = useState(false);
    const pathname = usePathname();

    // Close on navigation
    useEffect(() => {
        setIsOpen(false);
    }, [pathname]);

    // Close on Escape
    useEffect(() => {
        const handleEsc = (e: KeyboardEvent) => {
            if (e.key === "Escape") setIsOpen(false);
        };
        window.addEventListener("keydown", handleEsc);
        return () => window.removeEventListener("keydown", handleEsc);
    }, []);

    // Don't use early return to avoid "Rendered fewer hooks" issues if conditional logic fluctuates
    // if (pathname === "/") return null;

    const isHome = pathname === "/";

    return (
        <>
            {!isHome && (
                <button
                    type="button"
                    onClick={() => setIsOpen(true)}
                    className="p-2.5 text-gray-400 hover:text-white transition-colors hover:bg-white/10 rounded-full"
                    aria-label="Open Search"
                    aria-haspopup="dialog"
                >
                    <Search className="w-6 h-6" />
                </button>
            )}

            {/* Search Modal Overlay */}
            {isOpen && (
                <div role="dialog" aria-modal="true" aria-label="Search CouponSwift" className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-xl animate-in fade-in duration-200">
                    <div className="max-w-4xl mx-auto px-4 pt-32">
                        <div className="flex justify-end mb-8">
                            <button
                                type="button"
                                onClick={() => setIsOpen(false)}
                                aria-label="Close search"
                                className="p-2 text-gray-400 hover:text-white transition-colors rounded-full hover:bg-white/10"
                            >
                                <X className="w-8 h-8" />
                            </button>
                        </div>

                        <div className="text-center mb-8">
                            <h2 className="text-3xl font-bold text-white mb-2">Search CouponSwift</h2>
                            <p className="text-gray-400">Find the best deals for hosting, VPNs, and more.</p>
                        </div>

                        <GlobalSearch variant="hero" />
                    </div>
                </div>
            )}
        </>
    );
}
